import { URLS } from "@core/shared/utils";
import { cn } from "@design-system/utils";
import { trans } from "@mongez/localization";
import { buttonVariants } from "../Button";
import { ChevronLeftIcon } from "../Icons";
import { BaseLink } from "./Link";

type ReturnToHomeProps = {
  className?: string;
  variant?:
    | "outline"
    | "default"
    | "destructive"
    | "secondary"
    | "ghost"
    | "link";
};

export function ReturnToHome({
  className,
  variant = "outline",
}: ReturnToHomeProps) {
  return (
    <BaseLink
      to={URLS.home}
      className={cn("group gap-2", buttonVariants({ variant }), className)}
    >
      <ChevronLeftIcon className="transition group-hover:-translate-x-1 rtl:rotate-180" />
      {trans("returnToHome")}
    </BaseLink>
  );
}
